import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Scroller() {
  const setup = () => {
    const lenis = new Lenis();
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    window.addEventListener('resize', () => ScrollTrigger.refresh());
    window.addEventListener('orientationchange', () => ScrollTrigger.refresh());

    // if safari
    if (window.ApplePaySession) {
      window.addEventListener('load', () => {
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 10);
      });
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 1000);
    }
  };

  return {
    init: () => {
      setup();
    },
  };
}
